/**
 * @owner @Appboy/frontend-ix
 * @fileoverview GET handler for the "/dust/auth/:app_group_id" endpoint
 */

import type { DustConfigResponse } from "@lib/dust";
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";

export const getDustConfig = reactQueryFetcherAdapter(
  cacheKey,
  (signal: AbortSignal, appGroupId: string): Promise<DustConfigResponse> => {
    const url = `/dust/auth/${appGroupId}`;
    return fetch(url, "GET", undefined, { signal });
  }
);
